"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESEND_VERIFICATION_EMAIL_BUTTON_ID = exports.EMAIL_CONFIRM_ACTIONS_ID = exports.HUBSPOT_EMAIL_CONFIRM_BAR_ID = void 0;
var HUBSPOT_EMAIL_CONFIRM_BAR_ID = 'hs-email-confirm-bar';
exports.HUBSPOT_EMAIL_CONFIRM_BAR_ID = HUBSPOT_EMAIL_CONFIRM_BAR_ID;
var EMAIL_CONFIRM_ACTIONS_ID = 'hs-email-confirm-bar-actions';
exports.EMAIL_CONFIRM_ACTIONS_ID = EMAIL_CONFIRM_ACTIONS_ID;
var RESEND_VERIFICATION_EMAIL_BUTTON_ID = 'hs-email-confirm-bar-resend-button';
exports.RESEND_VERIFICATION_EMAIL_BUTTON_ID = RESEND_VERIFICATION_EMAIL_BUTTON_ID;